import type { DomainGuid } from '../..';
import type { GridElementType } from './GridElement';
import { GridElement } from './GridElement';

export class GridElementDictionary {
  constructor() {}
  private elements: Record<string, GridElement> = {};

  add(element: GridElementType): void {
    this.elements[element.id] = GridElement.Create(element);
  }

  replace(element: GridElementType): void {
    if (this.exists(element.id)) {
      this.elements[element.id] = GridElement.Create(element);
    } else {
      throw new Error(
        `Element with id ${element.id} does not exist in ${GridElementDictionary.name}.`
      );
    }
  }

  private exists(id: string): boolean {
    return !!this.elements[id];
  }

  private get(id: string): GridElement {
    return this.elements[id];
  }

  toRecord(): MapElementsDictionaryType {
    return this.elements;
  }

  toArray(): GridElement[] {
    return Object.values(this.elements);
  }

  forElement(
    elementId: string,
    callbacks: {
      exists: (mapElement: GridElement) => void;
      missing: () => void;
    }
  ): void {
    if (this.exists(elementId)) {
      callbacks.exists(this.get(elementId));
    } else {
      callbacks.missing();
    }
  }
}

export type MapElementsDictionaryType = Record<DomainGuid, GridElement>;
